import React from "react";
import { observer } from "mobx-react";
import { useHistory } from "react-router-dom";
import renderMarkdown from "../markdown";

const TextBlock = observer(({ block, isStreaming }) => {
  const history = useHistory();

  return (
    <div className="copilotText">
      {renderMarkdown(block.markdown, path => history.push(path))}
      {isStreaming && <span className="copilotText__cursor" />}
    </div>
  );
});

export default TextBlock;
